// import { FC, useRef, useState } from 'react';
// import { BsVolumeMuteFill, BsVolumeUpFill } from 'react-icons/bs';

// interface VideoPlayerProps {
//   src: string;
//   className?: string;
//   width?: number;
//   height?: number;
// }

// export const VideoPlayer: FC<VideoPlayerProps> = ({
//   src,
//   className,
//   width,
//   height,
// }) => {
//   const videoRef = useRef<HTMLVideoElement>(null);
//   const [isMuted, setIsMuted] = useState(true);

//   const toggleMute = () => {
//     if (videoRef.current) {
//       videoRef.current.muted = !videoRef.current.muted;
//       setIsMuted(videoRef.current.muted);
//     }
//   };

//   return (
//     <div
//       className={`relative w-full aspect-video rounded-[20px]`}
//       style={{ aspectRatio: `${width} / ${height}` }}
//     >
//       <video
//         ref={videoRef}
//         src={src}
//         autoPlay
//         loop
//         muted={isMuted}
//         playsInline
//         width={width}
//         height={height}
//         onContextMenu={(e) => e.preventDefault()}
//         className='w-full h-full object-cover'
//       />
//       <button
//         onClick={toggleMute}
//         className='absolute bottom-4 right-4 bg-black/50 text-white p-2 rounded-full'
//       >
//         {isMuted ? <BsVolumeMuteFill /> : <BsVolumeUpFill />}
//       </button>
//     </div>
//   );
// };

'use client';
import { FC, useRef, useState } from 'react';
import { BsVolumeMuteFill, BsVolumeUpFill } from 'react-icons/bs';

interface VideoPlayerProps {
  src: string;
  width?: number;
  height?: number;
  className?: string;
}

export const VideoPlayer: FC<VideoPlayerProps> = ({
  src,
  width,
  height,
  className = '',
}) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [isMuted, setIsMuted] = useState(true);

  const toggleMute = () => {
    if (videoRef.current) {
      videoRef.current.muted = !videoRef.current.muted;
      setIsMuted(videoRef.current.muted);
    }
  };

  return (
    <div
      className={`relative w-full h-full rounded-[20px] overflow-hidden ${className}`}
    >
      <video
        ref={videoRef}
        src={src}
        autoPlay
        loop
        width={width}
        height={height}
        muted={isMuted}
        playsInline
        onContextMenu={(e) => e.preventDefault()}
        className='absolute w-full h-full object-cover'
      />
      <button
        onClick={toggleMute}
        className='absolute bottom-4 right-4 bg-black/50 text-white p-2 rounded-full'
      >
        {isMuted ? <BsVolumeMuteFill /> : <BsVolumeUpFill />}
      </button>
    </div>
  );
};
